<template>
  <div>
    <v-autocomplete
      :clearable="canClear"
      :filled="setFill"
      :outlined="setOutline"
      :multiple="selectMultiple"
      :chips="useChips"
      :small-chips="useSmallChips"
      v-model="data"
      :items="choices"
      item-text="name"
      item-value="id"
      :hint="setHint"
      :persistent-hint="setPersistentHint"
      @input="handleInput"
    >
      <template #prepend v-if="prelabelDisplay">{{ prelabel }}: </template>
      <template #append-outer v-if="postlabelDisplay">
        {{ postlabel }}
      </template>
      <template #label v-if="fieldLabel">
        {{ label }}
      </template>
    </v-autocomplete>
  </div>
</template>
<script setup>
  import check from "@/../../library/helper/propertyCheck.js";
  import { computed, ref, onMounted } from "vue";

  // Define the properties
  const props = defineProps({
    config: {
      type: Object,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    postlabel: {
      type: String,
      required: false,
    },
    prelabel: {
      type: String,
      required: false,
    },
    choices: {
      required: true,
    },
    value: {type: [String, Number, Object, Array], required: true}
  });

  // Define emits
  const emit = defineEmits(["input"])

  // Define the data field for the contents
  let data = ref("")

  // Mount the intial data on the component
  onMounted(() => {
    data.value = props?.value
  })

  // Handle the user selection
  const handleInput = () => {
    emit("input", data.value)
  }

  // Property check method
  const propCheck = (key, value) =>
    check.checkSetting(props.config, key, value);

  // Settings
  const canClear = computed(() => propCheck("clear", true))
  const selectMultiple = computed(() => propCheck("multiple", true))
  const useChips = computed(() => propCheck("chips", false))
  const useSmallChips = computed(() => propCheck("smallchips", false))
  const setOutline = computed(() => propCheck("outline", false))
  const setFill = computed(() => propCheck("filled", false))
  const setBg = computed(() => propCheck("bgColor", undefined))
  const fieldLabel = computed(() => propCheck("label", false))
  const prelabelDisplay = computed(() => propCheck("prelabel", false))
  const postlabelDisplay = computed(() => propCheck("postlabel", false))
  const setHint = computed(() => propCheck("hint", undefined))
  const setPersistentHint = computed(() => propCheck("persistent_hint", false))

</script>